import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucThanhVien } from 'src/app/shared/DanhMucThanhVien.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class DanhMucThanhVienService extends BaseService{
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "DanhMucThanhVien";
    }
}

